<script>
    export let schedule;
    export let weeks;
    let selectedWeek;
    let selectedWeeksDays;
    let selectedDays = [];
    
    export let currWeek = 0;
    function updateDOWArray(index){
        selectedWeek = weeks[index];
        selectedWeeksDays = weeks[index].days;
        selectedDays = [];
        schedule = schedule;
    }
    function teamGamesOnSelectedWeek(teamGames){
        let startDate = new Date(selectedWeek.start);
        let endDate = new Date(selectedWeek.trueEnd);
        let ret_val = teamGames.filter(game => 
        {
            let gameDate = new Date(game.date);
            return startDate <= gameDate && gameDate <= endDate;
        });
        return ret_val;
    }
    function gamesOnSelectedDays(team) {
        var gameDays = [];
        let weeksGames = teamGamesOnSelectedWeek(schedule[team]);
        for (var game of weeksGames) {
            gameDays.push(game.date);
        }
        for (var day of selectedDays) {
            if (!gameDays.includes(day)) {
                return false;
            }
        }
        return true;
    }
    function buildTableRow(team) {
        let tableRow = `<tr><td>${team}</td>`;
        let weeksGames = teamGamesOnSelectedWeek(schedule[team]);
        for (var day of selectedWeeksDays) {
            var tableData = "<td></td>";
            for (var game of weeksGames) {
                if(game.date == day.date){
                    let atSymbol = game.home ? '@' : '';
                    tableData = `<td>${atSymbol}${game.opp}</td>`;
                    break;
                }
            }
            tableRow += tableData;
        }
        return tableRow+"</tr>";
    }
    function toShortDate(dateString){
        let date = new Date(dateString.replace(/-/g, '\/'));
        return date.toLocaleDateString('en-US', {month: 'short', day: 'numeric'});
    }
    updateDOWArray(currWeek);
</script>
<div>
    <div class="h4 fw-bold">Select Fantasy Week</div>
    <div class="btn-group">
        <div class="row">
        {#each weeks as week, index}
        <input id="option-{index}" class="btn-check" type=radio on:change={() => updateDOWArray(index)} bind:group={selectedWeeksDays} value={week.days}>
        <label for="option-{index}" class="col-4 btn btn-outline-primary">W{index+1}: {toShortDate(week.start)} - {toShortDate(week.end)} </label>
        {/each}
        </div>
    </div>
    <div class="h4 fw-bold">Show Teams Playing On</div>
    <div class="btn-group flex-wrap">
    {#each selectedWeek.days as swd, index}
    <input id="btn-check-{index}" autocomplete="off" class="btn-check" type=checkbox bind:group={selectedDays} value={swd.date} on:change={()=>{schedule=schedule}}>
    <label class="btn btn-outline-primary" for="btn-check-{index}">{swd.buttonName}</label>  
    {/each}
    </div>
    <div class="table-responsive card my-3 shadow" style="border-radius: 10px;">
        <table class="table overflow-hidden table-light table-hover table-bordered text-center" style="margin-bottom: 0px;">
            <thead class="table-dark"><tr><th>Team</th>
                {#each selectedWeeksDays as swd}
                <th>{swd.buttonName}</th>
                {/each}
                </tr>
            </thead>
            <tbody>
                {#each Object.entries(schedule) as [team_name, team_sched]}
                {#if gamesOnSelectedDays(team_name)}
                {@html buildTableRow(team_name)}
                {/if}
                {/each}
            </tbody>
        </table>
    </div>
</div>